class OntarioObstetricalSpecialCircumstances {
    public LowDoseAcetylsalicylicAcidIndicated?: boolean;
    public ProgesteroneIndicated?: boolean;
    public HerpesSuppressionIndicated?: boolean;
    public SocialCircumstances: string;

    constructor(fields?: Partial<OntarioObstetricalSpecialCircumstances>) {
        Object.assign(this, fields);
    }
}

export { OntarioObstetricalSpecialCircumstances };
